export default function TableConfig() {
  return {
    columns: [
      {
        dataIndex: 'paend_on',
        title: 'Дата записи',
        fixed: 'left',
        width: 120,
      },
      {
        dataIndex: 'pincode',
        title: 'Пин-код',
        width: 100,
      },
      {
        dataIndex: 'clientfio',
        title: 'ФИО',
        width: 180,
      },
      {
        dataIndex: 'clientmail',
        title: 'E-mail',
        width: 200,
      },
      {
        dataIndex: 'clientphone',
        title: 'Телефон',
        width: 140,
      },
      {
        dataIndex: 'open_data',
        title: 'Дата выдачи талона (если был выдан)',
        width: 180,
      },
      {
        dataIndex: 'close_data',
        title: 'Дата завершения',
        width: 140,
      },
      {
        dataIndex: 'q_name',
        title: 'Услуга',
        width: 200,
      },
      {
        dataIndex: 'ticket_number',
        title: 'Номер талона',
        width: 120,
      },
      {
        dataIndex: 'total_wait_time',
        title: 'Ожидание (мин)',
        width: 120,
      },
      {
        dataIndex: 'total_proc_time',
        title: 'Обслуживание (мин)',
        width: 140,
      },
      {
        dataIndex: 'fio',
        title: 'Оператор',
        width: 150,
      },
      {
        dataIndex: 'wp_name',
        title: 'Рабочее место',
        width: 140,
      },
      {
        dataIndex: 'status',
        title: 'Статус',
        width: 120,
      },
      {
        dataIndex: 'ticket_mark',
        title: 'Оценка',
        width: 100,
      },
      {
        dataIndex: 'slot_created',
        title: 'Дата создания слота',
        width: 150,
      },
      {
        dataIndex: 'registered',
        title: 'Зарегистрированный',
        width: 140,
      },
    ],
  };
}
